/**
 * RaceTrace Live: a lap still to come, with how many laps from now it is: "171 (23)", and a range
 * "149–171 (1–23)". Laps from now count from the car's laps done: the lap it is on is 1.
 */
export function lapAhead(lap: number, lapsDone: number): string {
  return `${lap} (${Math.max(0, lap - lapsDone)})`;
}

export function lapsAhead(from: number, to: number, lapsDone: number): string {
  return `${from}–${to} (${Math.max(0, from - lapsDone)}–${Math.max(0, to - lapsDone)})`;
}
